import { Box, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AssignmentTable } from '../../../../components/shared/tables/AssignmentTable';
import { MenuDto } from '../../../../app/services/api/range';
import { MenuDisplayStatusChip } from '../../components/MenuDisplayStatusChip';

interface RangeMenusTabProps {
  menus: MenuDto[];
  isLoading: boolean;
  assignedMenuIds: ReadonlySet<number>;
  originalAssignedMenuIds: ReadonlySet<number>;
  onToggle: (menuId: number) => void;
  onMenuClick: (menuId: number) => void;
  readOnly?: boolean;
}

const RangeMenusTab = ({ menus, isLoading, assignedMenuIds, originalAssignedMenuIds, onToggle, onMenuClick, readOnly = false }: RangeMenusTabProps) => {
  const { t } = useTranslation('range');

  return (
    <Box>
      <AssignmentTable<MenuDto>
        title={t('menus')}
        items={menus}
        getRowId={(row) => row.id}
        getSearchableText={(row) => row.name}
        assignedIds={assignedMenuIds}
        originalAssignedIds={originalAssignedMenuIds}
        onToggle={onToggle}
        readOnly={readOnly}
        onRowClick={(row) => onMenuClick(row.id)}
        loading={isLoading}
        pageSize={10}
        searchPlaceholder={t('searchPlaceholder')}
        emptyMessage={t('noMenusFound')}
        columns={[
          {
            id: 'name',
            label: t('name'),
            render: (row) => (
              <Link
                component="button"
                type="button"
                underline="hover"
                onClick={(event) => {
                  event.stopPropagation();
                  onMenuClick(row.id);
                }}
              >
                {row.name}
              </Link>
            ),
          },
          {
            id: 'menuType',
            label: t('menuType'),
            render: (row) => (row.menuType ? t(`menuType${row.menuType}`) : t('notSet')),
          },
          {
            id: 'status',
            label: t('status'),
            render: (row) => <MenuDisplayStatusChip status={row.displayStatus} />,
          },
        ]}
      />
    </Box>
  );
};

export default RangeMenusTab;

